import { memo } from 'react'

// Actions
import { actions as browseActions } from 'modules/browse/actions'

// Components
import { Layout, PageHeading } from '@tracklib/kit'
import Filter from 'components/filter'
import SearchDescription from 'components/browse/searchdescription'
import SEO from 'components/base/seo'
import TrackList from 'components/browse/tracklist'

// Hooks
import { useSearchQuery, useCurrentQuery } from 'modules/browse/hooks'

// Selectors
import { selectSearchToQuery } from 'modules/browse/selectors'

// Types
import { Dispatch, GetState } from 'types'

// Utils
import { createSearchQuery } from 'pages/collection'

export const loadInitialData = () => async (dispatch: Dispatch, getState: GetState) => {
  const queryObject = selectSearchToQuery(getState())
  const searchQuery = createSearchQuery(queryObject, '')
  return dispatch(browseActions.fetchTracksBySearchQuery(searchQuery))
}

const BrowsePage = () => {
  const activeQuery = useCurrentQuery()
  const filtersActive = !!Object.keys(activeQuery)?.length
  const trackListProps = useSearchQuery()
  const title = 'Browse tracks to sample on Tracklib'
  const description =
    'Browse for tracks to sample on Tracklib. The crate digging and sampling service where every single song can be licensed for release within minutes.'
  return (
    <Layout.FullWidth>
      <SEO title={title} description={description} />
      <PageHeading
        noPad
        heading="All tracks"
        description={
          filtersActive ? <SearchDescription asString /> : 'Browse through our catalog of original songs, stems and multi-tracks'
        }
      />
      <Filter />
      <TrackList emptyStateMessage="No results." {...trackListProps} />
    </Layout.FullWidth>
  )
}

export default memo(BrowsePage)
